module.exports = __webpack_public_path__ + "static/img/bg-fr.7c3b1d2b.png";